<app-table [data]="toolRequestHistory"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [title]="'admin.request-history.request-history-table.title' | translate"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (rowClick)="onRowClick($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'admin.request-history.request-history-table.columns.requestName' | translate"
                      [filterPlaceholder]="'admin.request-history.request-history-table.filter.placeholder.requestName' | translate"
                      [filter]="true"
                      field="name">
        <ng-template #body
                     let-toolRequestHistory="rowData">
            <span>{{ toolRequestHistory.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.request-history.request-history-table.columns.partNumber' | translate"
                      [filterPlaceholder]="'admin.request-history.request-history-table.filter.placeholder.partNumber' | translate"
                      [filter]="true"
                      field="partNumber">
        <ng-template #body
                     let-toolRequestHistory="rowData">
            <span>{{ toolRequestHistory.partNumber?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.request-history.request-history-table.columns.requestStatus' | translate"
                      field="requestStatus">
        <ng-template #body
                     let-request="rowData">
            <span>{{ request.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.request-history.request-history-table.columns.createdBy' | translate"
                      [filterPlaceholder]="'admin.request-history.request-history-table.filter.placeholder.createdBy' | translate"
                      [filter]="true"
                      field="createdBy">
        <ng-template #body
                     let-toolRequestHistory="rowData">
            <span>{{ toolRequestHistory.createdBy?.firstName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column #date
                      [sortable]="true"
                      [header]="'admin.request-history.request-history-table.columns.createdDate' | translate"
                      field="createdDate">
    </app-table-column>

    <app-table-column [header]="'admin.request-history.request-history-table.columns.modifiedBy' | translate"
                      field="modifiedBy">
        <ng-template #body
                     let-toolRequestHistory="rowData">
            <span>{{ toolRequestHistory.modifiedBy?.firstName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column #date
                      [sortable]="true"
                      [header]="'admin.request-history.request-history-table.columns.modifiedDate' | translate"
                      field="modifiedDate">
    </app-table-column>
    <app-table-column [header]="'admin.request-history.request-history-table.columns.requestType' | translate"
                      field="type">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterTypeList"
                          valueField="value"
                          displayField="name"
                          [emptyText]="'admin.request-history.request-history-table.filter.placeholder.requestType' | translate"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-request="rowData">
            <span>{{ request.type | translate }}</span>
        </ng-template>
    </app-table-column>
</app-table>
